import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { bannerImgUrls, ButtonStripWrapper, EmployeeLoginLink, LoginCard, PageWrapper, Slide, SliderWrapper, SlideWrapper, StyledButton, StyledButtons, StyledHeading, StyledImage, upimg, WelcomeSlideText } from './Styled';
import { Box} from '@mui/material';
import { useForm } from "react-hook-form";
import InputContainer from '../../../../../../obps/src/pages/citizen/TCPForms/layout/inputContainer';
import ButtonWrapper from '../../../../../../obps/src/pages/citizen/TCPForms/components/Button';
import { Toast } from '@egovernments/digit-ui-react-components';
import { useLocation } from 'react-router-dom';

const AVPLogin = () => {
    const getUserType = () => Digit.UserService.getType();
    const navigate = useHistory();
    const stateId = Digit.ULBService.getCurrentTenantId();
    const [showOtpField, setOtpField] = useState(false)
    const [showsecotpField, setSecondOtpField] = useState(false)
    const [showName, setName] = useState(false)
    const [showToast, setShowToast] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0)
    const [loginSection, setLoginSection] = useState(false)
    const location = useLocation();
    const homepath = location?.pathname?.includes("digit-ui/citizen")
    const { handleSubmit, control, setValue, getValues, watch, reset } = useForm({});
    const closeToast = () => {
        setShowToast(null)
    };

    useEffect(() => {
        if (!showToast) return;
        const timeOut = setTimeout(closeToast, 3000)
        return () => clearTimeout(timeOut);
    }, [showToast]);

    useEffect(() => {
        let timer = setInterval(() => {
            setCurrentSlide(curr => curr + 1 < bannerImgUrls.length ? curr + 1 : 0)
        }, 3000)

        return () => clearInterval(timer)
    }, [])

    const onSubmit = async (data) => {
        console.log(data);
        const { mobileNumber, otp, registeredName } = data
        if (!showOtpField && !showName) {
            const requestData = {
                otp: {
                    mobileNumber: mobileNumber,
                    userType: "citizen",
                    type: "login",
                    tenantId: stateId,
                },
            };
            try {
                const res = await Digit.UserService.sendOtp(requestData, stateId);
                if (res?.isSuccessful) {
                    setOtpField(true)
                }
            } catch (err) {
                setName(true)
                setShowToast({ error: true, message: `New User? Please register your detail in the portal` });
            }
        }
        console.log(otp, registeredName, showName, showOtpField, showsecotpField, "alllllll");
        if (showsecotpField) {
            const requestData = {
                name: registeredName,
                username: mobileNumber,
                otpReference: otp,
                tenantId: stateId,
                mobileNumber: mobileNumber
            };
            try {
                const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.registerUser(requestData, stateId);
                Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
                Digit.UserService.setUser({ info, ...tokens });
                navigate.push('/digit-ui/citizen/profile')
            }

            catch (error) {
                setShowToast({ error: true, message: `Something went wrong, please try again!` });
            }
        }
        if (showName && !showOtpField && !showsecotpField) {
            const requestData = {
                otp: {
                    mobileNumber: mobileNumber,
                    name: registeredName,
                    userType: "citizen",
                    type: "register",
                    tenantId: stateId,
                },
            };
            try {
                const res = await Digit.UserService.sendOtp(requestData, stateId);
                if (res?.isSuccessful) {
                    setSecondOtpField(true)
                }
            } catch (err) {
                setShowToast({ error: true, message: `Something went wrong, please try again!` });
            }
        }
        if (showOtpField && !showName) {
            const requestData = {
                username: mobileNumber,
                password: otp,
                tenantId: stateId,
                userType: getUserType(),
            };
            try {
                const { ResponseInfo, UserRequest: info, ...tokens } = await Digit.UserService.authenticate(requestData);
                Digit.SessionStorage.set("citizen.userRequestObject", { info, ...tokens });
                Digit.UserService.setUser({ info, ...tokens });
                navigate.push('/digit-ui/citizen/profile')
            } catch (error) {
                setShowToast({ error: true, message: `Something went wrong, please try again!` });
            }
        }
    };

    return (
        <PageWrapper style={{ marginTop: homepath ? '-80px' : '0px' }}>
            {/* Left 50% with Slider */}
            <SliderWrapper>
                <SlideWrapper key={currentSlide} bgimg={bannerImgUrls[currentSlide]}>
                    <WelcomeSlideText>
                        Fast & Simplified Trust Based Plan Approval System
                    </WelcomeSlideText>
                </SlideWrapper>
                {/* <Slide style={{ backgroundImage: `url('https://i.imgur.com/CVonZnW.jpeg')` }} /> */}
            </SliderWrapper>


            {/* Right 50% with Login Card */}
            <LoginCard>
                <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'center', alignItems: 'center' }}>
                    <StyledImage src={upimg} alt="upimage" />
                    <StyledHeading>Awas Evam Vikas Parishad</StyledHeading>
                </Box>
                <StyledHeading>Fast & Simplified Trust Based Plan Approval System</StyledHeading>
                <ButtonStripWrapper>
                    <StyledButtons onClick={() => setLoginSection(true)}>Online Services</StyledButtons>
                    <StyledButtons onClick={() => navigate.push('/digit-ui/employee')}>Officer Login</StyledButtons>
                    <StyledButtons onClick={() => window.open("https://www.coa.gov.in/", "_blank")}>COA Verification Link</StyledButtons>
                </ButtonStripWrapper>
                {loginSection && <section className="container1" style={{ marginTop: 0 }}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        <div className="formContainer">
                            <div className="formHeaderContainer">
                                <h2 className="formHeading">User Login</h2>
                            </div>
                            <div className="formInputContainer">
                                <div className="columnWrapper" style={{ flex: '0 0' }}>
                                    <InputContainer
                                        control={control}
                                        placeholder="Enter Mobile No."
                                        //defaultValue={owner.mobileNumber}
                                        name="mobileNumber"
                                        type="textInput"
                                        label={"Enter Mobile No."}
                                        mobileNumber
                                        validation={{
                                            required: {
                                                value: true,
                                                message: "This field is required"
                                            },
                                            pattern: {
                                                value: Digit.Utils.getPattern('MobileNo'),
                                                message: "Please enter valid mobile no",
                                            },
                                        }}
                                        maxLength={10}
                                    />
                                    {showName &&
                                        <InputContainer
                                            control={control}
                                            placeholder="Enter Name"
                                            //defaultValue={owner.mobileNumber}
                                            name="registeredName"
                                            type="textInput"
                                            label={"Enter Name"}
                                            validation={{
                                                required: {
                                                    value: true,
                                                    message: "This field is required"
                                                },
                                                pattern: {
                                                    value: Digit.Utils.getPattern('Name'),
                                                    message: "Please enter only letters and spaces",
                                                },
                                            }}
                                        />}
                                    {(showOtpField || showsecotpField) && <InputContainer
                                        control={control}
                                        placeholder="Enter Otp"
                                        //defaultValue={owner.mobileNumber}
                                        name="otp"
                                        type="textInput"
                                        label={"Enter OTP"}
                                        maxLength={6}
                                    />}
                                </div>
                            </div>
                            <div style={{ marginLeft: '25%' }}>
                                <ButtonWrapper
                                    variant="contained"
                                    size="medium"
                                    label="Next"
                                    type="submit"
                                    sx={{ backgroundColor: '#1F4A7C', width: '10%', marginBottom: '3%' }}
                                />
                            </div>
                        </div>

                    </form>
                </section>}
                {
                    showToast && (
                        <Toast
                            error={showToast?.error}
                            warning={showToast?.warning}
                            label={showToast?.message}
                            onClose={closeToast}
                            isDleteBtn={true}
                        />
                    )
                }
            </LoginCard>
        </PageWrapper>
    );
};

export default AVPLogin;